<p
[ngStyle]="{backgroundColor: getColor()}"
[ngClass]="{'offline': serverStatus === 'offline', 'online': serverStatus === 'online'}">
    Server with ID {{serverId}} is {{serverStatus}}
</p>